import React from "react";
import UserMenu from "../../containers/common/UserMenu";
import styles from "../../css/messagePage.less";

class MessagePage extends React.Component {
    render() {
        const messageData = this.props.messageData;
        if (!messageData) {
            return null;
        }
        let messageBody = messageData.messageBody;
        if (messageData.messageExtra) {
            messageBody += '<br>' + messageData.messageExtra;
        }

        const showMemberMenu = this.props.memberKey !== undefined;
        const bodyClassName = "message-body" + (messageData.messageExtra ? ' message-extra' : '');
        return (
            <div className="message-main-container">
                {showMemberMenu ?
                    <div className="member-dropdown">
                        <UserMenu/>
                    </div>
                    : undefined
                }
                <div className={"message-container" + (showMemberMenu ? " show-member-menu" : "")}>
                    <div className="message-title" id="messageTitle" dangerouslySetInnerHTML={{__html: messageData.messageTitle}}/>
                    <div className={bodyClassName} id="messageBody" dangerouslySetInnerHTML={{__html: messageBody}}/>
                    {this.props.link ?
                        <div className="link-back">
                            <a className="link-back-a" href={this.props.link.url}>{this.props.link.text}</a>
                        </div>
                        :undefined
                    }
                    {this.props.action ?
                        (this.props.action.type === 'button' ?
                            <div className="action">
                                <button className='button btn btn-primary' onClick={this.props.action.callback}>
                                    {this.props.action.text}
                                </button>
                            </div>
                            :
                            <div className="action" onClick={this.props.action.callback}>
                                {this.props.action.text}
                            </div>)
                        :undefined
                    }
                </div>
            </div>);
    }
}

export default MessagePage;


// WEBPACK FOOTER //
// ./src/components/common/MessagePage.js